import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	isModalOpen: false,
};

const timedOutReducerSlice = createSlice({
	initialState: initialState,
	name: 'timedOutReducer',
	reducers: {
		setTimedOutModal(state, action) {
			return { ...action.payload };
		},
		resetTimedOutModal() {
			return {
				isModalOpen: false,
			};
		},
	},
});

export const { setTimedOutModal, resetTimedOutModal } =
	timedOutReducerSlice.actions;
export default timedOutReducerSlice.reducer;
